import { render, staticRenderFns } from "./bench.vue?vue&type=template&id=23a879cc&scoped=true&"
import script from "./bench.ts?vue&type=script&lang=ts&"
export * from "./bench.ts?vue&type=script&lang=ts&"
import style0 from "./bench.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./bench.vue?vue&type=style&index=1&id=23a879cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a879cc",
  null
  
)

export default component.exports